import React, { Component } from 'react';
import TabsContainer from '../../components/views/TabsContainer';
import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import ViewsTable from '../../components/tables/ViewsTable';
import PaymentPage from './paymentMethodForm';
import API from '../../utils/API';
const states = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
    'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
    'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
    'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
    'Wisconsin', 'Wyoming'
];
const stateOptions = states.map(state => ({ label: state, value: state }));

const countryOptions = [
    { label: 'United States', value: 'US' },
    { label: 'Canada', value: 'CA' },
    { label: 'Mexico', value: 'MX' }
]

const columns = [
    { label: 'Date Due', key: 'date', type: 'date', value: 'date' },
    { label: 'Payment Method', key: 'paymentMethod', type: 'text', value: 'paymentMethod' },
    { label: 'Amount', key: 'amount', type: 'currency', value: 'amount' },
    { label: 'Status', key: 'status', type: 'richText', value: 'status' }
];

const toggledColumns = {
    date: true,
    paymentMethod: true,
    amount: true,
    status: true
};

const widths = {
    date: 120,
    paymentMethod: 200,
    amount: 150,
    status: 100
}

class Billing extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedSection: 0,
            configuringPaymentMethod: false,
            paymentMethod: props.subscription.paymentMethod,
            customerInfo: {
                ...props.subscription.customer
            },
            clientSecret: '',
            fetchingPaymentIntent: false,
            paymentMethodsOpen: false,
            isUpdatingPaymentMethod: false
        }
    }

    updateCustomerInfo = async () => {
        const { orgId } = this.props;
        const { customerInfo } = this.state;
        if (!customerInfo.name || !customerInfo.email) return;
        this.setState({ updatingCustomer: true });
        const customer = {};
        if (customerInfo.name) customer.name = customerInfo.name;
        if (customerInfo.email) customer.email = customerInfo.email;
        if (customerInfo.phone) customer.phone = customerInfo.phone;
        if (customerInfo.address) {
            if (customerInfo.address.line1) customer.address = { ...customer.address, line1: customerInfo.address.line1 };
            if (customerInfo.address.line2) customer.address = { ...customer.address, line2: customerInfo.address.line2 };
            if (customerInfo.address.city) customer.address = { ...customer.address, city: customerInfo.address.city };
            if (customerInfo.address.postal_code) customer.address = { ...customer.address, postal_code: customerInfo.address.postal_code };
            if (customerInfo.address.country) customer.address = { ...customer.address, country: customerInfo.address.country.value };
            if (customerInfo.address.state) customer.address = { ...customer.address, state: customerInfo.address.state.value };
        }
        await API().patch(`/Organizations/${orgId}/account/updateCustomer`, {
            ...customer
        });
        this.setState({ updatingCustomer: false });
    }

    updatePaymentMethod = async (paymentMethodId) => {
        const { orgId } = this.props;
        this.setState({isUpdatingPaymentMethod: true});
        const res = await API().patch(`/Organizations/${orgId}/updatePayment`, {
            paymentMethodId: paymentMethodId
        });
        if(res.data){
            this.setState({ paymentMethod: res.data, isUpdatingPaymentMethod: false }, () => this.updateDefaultPaymentMethod(res.data));
        }
    }

    getPaymentIntent = async () => {
        const { orgId } = this.props;
        this.setState({ fetchingPaymentIntent: true });
        const response = await API().get(`/Organizations/${orgId}/account/paymentIntent`);
        const clientSecret = response.data.clientSecret;
        this.setState({ clientSecret, configuringPaymentMethod: true, fetchingPaymentIntent: false });
    }

    showPaymentMethods = () => {
        this.setState({ paymentMethodsOpen: true });
    }

    updatePaymentMethods = (paymentMethods) => {
        const updatedSubscription = { ...this.props.subscription };
        updatedSubscription.paymentMethods = paymentMethods;
        this.props.updateSubscription(updatedSubscription);
    }

    updateDefaultPaymentMethod = (paymentMethod) => {
        const updatedSubscription = { ...this.props.subscription };
        updatedSubscription.paymentMethod = paymentMethod;
        this.props.updateSubscription(updatedSubscription);
    }

    render() {
        const { selectedSection, paymentMethod, fetchingPaymentIntent, paymentMethodsOpen, isUpdatingPaymentMethod } = this.state;
        const { subscription, orgId } = this.props;
        return (
            <>
                <TabsContainer
                    selectedIndex={selectedSection}
                    updateSelected={(index) => this.setState({ selectedSection: index })}
                    tabs={[
                        { title: 'Overview' },
                        { title: 'Settings' },
                        { title: 'Invoices' },
                        { title: 'Payment Method' },
                        //{ title: 'Billing Contacts' }
                    ]}
                />
                <div style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 85px)', height: '100%' }}>
                    {selectedSection === 0 && <>
                        <div className='sectionBlock p-20' style={{ maxWidth: 800 }}>
                            <h2 className='mb-10 semibold'>Billing Overview</h2>
                            <div className='outlineCard mb-30'>
                                <div className='flex jcsb'>
                                    <div>
                                        <h4 className='mb-10'>Billing Period</h4>
                                        <h3>{subscription.annual ? 'Yearly' : subscription.monthly ? 'Monthly' : 'Unset'}</h3>
                                    </div>
                                    <div>
                                        <h4 className='mb-10'>Renewal Date</h4>
                                        <h3>{subscription.renewalDate}</h3>
                                    </div>
                                    <div>
                                        <h4 className='mb-10'>Total</h4>
                                        <h3>${subscription.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h3>
                                    </div>
                                </div>
                            </div>
                            <div className='flex jcsb aic mb-5'>
                                <h2 className='semibold'>Products</h2>
                                <button className='text'><i className='las la-plus mr-10'></i>Add more products</button>
                            </div>
                            <div className='outlineCard mb-10'>
                                <div className='flex aic mb-20'>
                                    <h3>simple.events</h3>
                                </div>
                                <div className='flex jcsb mb-20'>
                                    <div>
                                        <h4 className='mb-10'>Tier</h4>
                                        <h3>{subscription.inTrial ? 'Trial' : 'Enterprise'}</h3>
                                    </div>
                                    <div>
                                        <h4 className='mb-10'>Seats</h4>
                                        <h3>{subscription.filled}/{subscription.seats}</h3>
                                    </div>
                                    <div>
                                        <h4 className='mb-10'>Members</h4>
                                        <h3>{subscription.filled}</h3>
                                    </div>
                                    <div>
                                        <h4 className='mb-10'>Guests</h4>
                                        <h3>0</h3>
                                    </div>
                                    <div>
                                        <h4 className='mb-10'>Renewal Amount</h4>
                                        <h3>${subscription.licenseAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h3>
                                    </div>
                                </div>
                            </div>
                            {subscription.addons && subscription.addons.length > 0 && subscription.addons.map((addon, index) => {
                                return <div className='outlineCard mb-10 flex aic jcsb'>
                                    <div>
                                        <h4>{addon.name}</h4>
                                        <h3>${addon.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h3>
                                    </div>
                                    <button className='danger text'>
                                        Cancel
                                    </button>
                                </div>
                            })}

                            <h2 className='mb-10 mt-20 semibold'>Need help?</h2>
                            <div className='flex gap20'>
                                <div className='outlineCard flex aic gap20' style={{ flex: 2 }}>
                                    <div>
                                        <i className='las la-question-circle la-5x seBlue'></i>
                                    </div>
                                    <div className='flex column jcc'>

                                        <h3 className='mb-10'>Questions?</h3>
                                        <p>For more information about billing and pricing, visit our <a href="#">knowledge base</a></p>
                                    </div>
                                </div>
                                <div className='outlineCard flex column aic text-c' style={{ flex: 1 }}>
                                    <h3 className='mb-10'>Contact support</h3>
                                    <p className='mb-20'>Our support team is here to help with any questions you may have!</p>
                                    <button className='prim mb-10'>Contact Support</button>
                                    <button className='danger text'>Pause subscription</button>
                                </div>
                            </div>
                        </div>
                    </>}
                    {selectedSection === 1 && <>
                        <div className='sectionBlock p-20'>
                            <h2 className='mb-5 semibold'>Billing Settings</h2>
                            <p className='small mb-20'>Any changes will be applied to your upcoming invoices.</p>
                            <div className='outlineCard'>
                                <div className='flex gap10'>
                                    <InputField label="Billing Full Name"
                                        required={true}
                                        value={this.state.customerInfo.name}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, name: e.target.value } })} />
                                </div>
                                <div className='flex gap10'>
                                    <InputField label="Billing Email"
                                        required={true}
                                        value={this.state.customerInfo.email}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, email: e.target.value } })} />
                                    <InputField label="Phone Number"
                                        value={this.state.customerInfo.phone}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, phone: e.target.value } })} />
                                </div>
                                <div className='flex gap10'>
                                    <InputField label="Address 1"
                                        value={this.state.customerInfo.address ? this.state.customerInfo.address.line1 : ''}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, address: { ...this.state.customerInfo.address, line1: e.target.value } } })} />
                                    <InputField label="Address 2"
                                        value={this.state.customerInfo.address ? this.state.customerInfo.address.line2 : ''}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, address: { ...this.state.customerInfo.address, line2: e.target.value } } })} />
                                </div>
                                <div className='flex gap10'>
                                    <InputField label="City"
                                        value={this.state.customerInfo.address ? this.state.customerInfo.address.city : ''}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, address: { ...this.state.customerInfo.address, city: e.target.value } } })}
                                    />
                                    <InputField label="Postal Code"
                                        value={this.state.customerInfo.address ? this.state.customerInfo.address.postal_code : ''}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, address: { ...this.state.customerInfo.address, postal_code: e.target.value } } })}
                                    />
                                </div>
                                <div className='flex gap10'>
                                    <SelectField label="Country" options={countryOptions}
                                        value={this.state.customerInfo.address && this.state.customerInfo.address.country ? countryOptions.find(c => c.value === this.state.customerInfo.address.country) : ''}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, address: { ...this.state.customerInfo.address, country: e } } })}
                                    />
                                    <SelectField label="State" options={stateOptions}
                                        value={this.state.customerInfo.address && this.state.customerInfo.address.state ? stateOptions.find(s => s.value === this.state.customerInfo.address.state) : ''}
                                        onChange={(e) => this.setState({ customerInfo: { ...this.state.customerInfo, address: { ...this.state.customerInfo.address, state: e } } })}
                                    />
                                </div>
                                <button className={`prim mt-10 ${!subscription.customer ? 'disabled' : ''}`}
                                    onClick={this.updateCustomerInfo}
                                >Update</button>
                            </div>
                        </div>
                    </>}
                    {selectedSection === 2 && <>
                        <div className='sectionBlock p-10 h-100 invoices' style={{ maxWidth: 800 }}>
                            <ViewsTable
                                title='Invoices'
                                columns={columns}
                                toggledColumns={toggledColumns}
                                data={subscription.invoices}
                                checked={[]}
                                disableCheck={true}
                                columnWidths={widths}
                                rowSettings={[{
                                    label: 'View Invoice',
                                    onClick: (id) => {
                                        const invoice = subscription.invoices.find(inv => inv._id === id);
                                        window.open(invoice.invoiceUrl, '_blank');
                                    }
                                }]}
                                classes="noBorder"
                                disableColumnResizing={true}
                            />
                        </div>
                    </>}
                    {selectedSection === 3 && <>
                        <div className='sectionBlock p-20'>
                            {!paymentMethodsOpen && !this.state.configuringPaymentMethod && (paymentMethod ? <div className='flex aic jcsb gap30' style={{ borderBottom: '1px solid #bbb', height: 50 }}>
                                <h3>{paymentMethod.card ? 'Credit Card' : 'Bank Account'}</h3>
                                <div className='flex aic'>{paymentMethod.card ? <><i style={{ fontSize: 28 }} className={`lab la-cc-${paymentMethod.card.brand} mr-5`}></i> {' **** ' + paymentMethod.card.last4}</> : paymentMethod.us_bank_account.bank_name + ' **** ' + paymentMethod.us_bank_account.last4}</div>
                                <button className={`neu ${(!subscription.status || fetchingPaymentIntent || isUpdatingPaymentMethod) ? 'disabled' : ''}`} onClick={this.showPaymentMethods}>
                                    Change Payment Method
                                </button>
                            </div> : <div className='flex aic jcsb gap30' style={{ borderBottom: '1px solid #bbb', height: 50 }}>
                                <p>No Payment Method Added</p>
                                <button className={`neu ${(!subscription.status || fetchingPaymentIntent || isUpdatingPaymentMethod) ? 'disabled' : ''}`} onClick={this.getPaymentIntent}>
                                    Add Payment Method
                                </button>
                            </div>)}

                            {paymentMethodsOpen && !this.state.configuringPaymentMethod && <>
                            <div className='flex aic jcsb gap30' style={{ borderBottom: '1px solid #bbb', height: 50 }}>
                                <h3>Payment Methods</h3>
                                <button className='text' onClick={() => this.setState({ paymentMethodsOpen: false })}>
                                    Close
                                </button>
                            </div>
                                {subscription.paymentMethods && subscription.paymentMethods.length > 0 && <div className='flex column gap10'>
                                    {subscription.paymentMethods.map((method, index) => {
                                        return <div className='flex aic jcsb gap20' style={{ borderBottom: '1px solid #bbb', height: 50 }}>
                                            <div className='flex aic'>{method.card ? <><i style={{ fontSize: 28 }} className={`lab la-cc-${method.card.brand} mr-5`}></i> {' **** ' + method.card.last4}</> : method.us_bank_account.bank_name + ' **** ' + method.us_bank_account.last4}</div>
                                            <button className='neu' onClick={() => {
                                                this.updatePaymentMethod(method.id);
                                                this.setState({ paymentMethodsOpen: false });
                                            }}>
                                                Select
                                            </button>
                                        </div>
                                    })}
                                    <button className={`neu mt-20 ${(!subscription.status || fetchingPaymentIntent || isUpdatingPaymentMethod) ? 'disabled' : ''}`} onClick={this.getPaymentIntent}>
                                    Add Payment Method
                                </button>
                                </div>}
                            </>}

                            {this.state.configuringPaymentMethod && <PaymentPage updatePaymentMethods={this.updatePaymentMethods} orgId={orgId} clientSecret={this.state.clientSecret} subscription={subscription} close={(updatedPaymentMethod) => {
                                if (updatedPaymentMethod && updatedPaymentMethod.id) this.setState({ configuringPaymentMethod: false, paymentMethod: updatedPaymentMethod });
                                else this.setState({ configuringPaymentMethod: false });
                            }} />}
                        </div>
                    </>}
                    {/* selectedSection === 4 && <>
                        <div className='sectionBlock p-20'>
                            <h2 className='mb-10 semibold'>Manage Billing Contacts</h2>
                            <p>Anyone you add as a billing contact will receive email notifications when billing changes are made to your account. Please note, only Admins and user with the relevant Privileges have the ability to access and make billing changes within an account.</p>
                        </div>
                    </> */}
                </div>
            </>
        );
    }
}
export default Billing;
